<template>
  <div>
    <van-tabs @click="tabClick" sticky swipeable :offset-top="300">
      <van-tab title="待使用"></van-tab>
      <van-tab title="全部"></van-tab>
    </van-tabs>

    <no-data v-if="dataLoaded&&orders.length===0" :content-height="contentHeight"></no-data>
    <van-list v-else v-model="loading" :finished="finished" @load="onLoad" class="dataDiv">
      <van-cell-group class="pd dsfsdtytwer">
        <van-cell
          v-for="order in orders"
          :key="order.listNo"
          @click="onPanelClick(order.listNo)"
          class
        >
          <p class="z6 fz14 pt5 dstywwe pm5">订单编号：{{order.listNo}}</p>
          <div class="mt10" style="display: flex; align-items: center;">
            <span class="pr f_b">
              <i class="f_i binknxerrt"></i>
              <span class="kkmnmxerert">参观区域</span>
            </span>
            <span class="ml10 fz14 z6" style="font-weight: bold;line-height: 27px;">{{order.ticketTypeNames}}</span>
          </div>
          <div class="mt10" style="display: flex; align-items: center;">
            <span class="pr f_b">
              <i class="f_i binknxerrt"></i>
              <span class="kkmnmxerert">使用时间</span>
            </span>
            <span class="ml10 fz14 z6"  style="bold;line-height: 27px;">{{order.travelDate}}</span>
          </div>
          <div class="mt10" style="display: flex; align-items: center;">
            <span class="pr f_b">
              <i class="f_i binknxerrt"></i>
              <span class="kkmnmxerert">游客人数</span>
            </span>
            <span class="ml10 fz14 z6" style="bold;line-height: 27px;">{{order.totalNum}}</span>
          </div>
          <div v-if="order.arrivalTime" class="mt10"  style="display: flex; align-items: center;">
            <span class="pr f_b">
              <i class="f_i binknxerrt"></i>
              <span class="kkmnmxerert">讲解时间</span>
            </span>
            <span class="ml10 fz14 z6"  style="bold;line-height: 27px;">{{order.arrivalTime}}</span>
          </div>
           <div class="jnxeertx qr"><img src="./../assets/img/qr.png" style=" width: 50px;  height: 50px; margin-left:10px;" ><p><span class="fz14">查看二维码</span></p></div>
          
          <!-- <i v-if="order.orderStatusName=='已审核'" class="f_i jnxeertx"></i>
          <i v-else-if="order.orderStatusName=='已过期'" class="f_i jnxeertx ab"></i>
          <i v-else-if="order.orderStatusName=='已取消'" class="cancel"></i>
          <i v-else-if="order.orderStatusName=='已完成'" class="complete"></i> -->
        </van-cell>
      </van-cell-group>
    </van-list>
    <!-- <div v-if="showOrderInfo">
      <van-nav-bar
        title="订单明细"
        left-text="返回"
        left-arrow
        right-text="关闭"
        :z-index="3000"
        fixed
        @click-left="onCloseOrderInfo"
        @click-right="onCloseOrderInfo"
      />
    </div>-->
    <div v-if="showOrderInfo" class="pd row navBar">
      <p class="col">
        <img src="../assets/img/logo.png" class="loginnhjer cz" />
      </p>
      <span class="cf fz15" @click="toHome">首页</span>
    </div>
    <van-popup v-model="showOrderInfo" position="right" :overlay="false" class="orderinfo">
      <order-info :list-no="showListNo" :show-chang-ci="showChangCi" :show-navbar="true" :show-order-info="showOrderInfo" />
    </van-popup>
  </div>
</template>

<script>
import orderService from "@/services/orderService.js";
import OrderInfo from "./OrderInfo.vue";
import NoData from "@/components/NoData.vue";

export default {
  components: {
    OrderInfo,
    NoData,
  },
  data() {
    return {
      scrollTop: 0,
      loading: false,
      dataLoaded: false,
      finished: false,
      queryInput: {
        used: "false",
        skipCount: 0,
        maxResultCount: 20,
      },
      orders: [],
      showOrderInfo: false,
      showChangCi: { show: false },
      showListNo: "",
    };
  },
  computed: {
    contentHeight() {
      return this.$store.state.clientHeight - 150;
    },
  },
  methods: {
    async tabClick(index) {
      this.queryInput.used = index === 0 ? "false" : "";
      this.queryInput.skipCount = 0;
      this.orders = [];
      await this.getOrders();
    },
    async onLoad() {
      await this.getOrders();
    },
    onPanelClick(listNo) {
      this.showListNo = listNo;
      this.showChangCi.show = false;
      this.showOrderInfo = true;
    },
    toHome() {
      this.showOrderInfo = false;
      this.$router.push("/");
    },
    async onCloseOrderInfo() {
      if(this.showChangCi.show)
      {        
        this.showChangCi.show = false;
        return;
      }
      this.showOrderInfo = false;
      let result = await orderService.getMemberOrderForMobileAsync(
        this.showListNo
      );
      
      for (let i = 0; i < this.orders.length; i++) {
          if(this.orders[i].listNo==this.showListNo)
          {
            this.orders[i].orderStatus=result.orderStatus;
            this.orders[i].orderStatusName=result.orderStatusName;
          }
      }   
    },
    async getOrders() {
      try {
        this.loading = true;
        this.dataLoaded = false;

        let result = await orderService.getMemberOrdersForMobileAsync(
          this.queryInput
        );
        for (let i = 0; i < result.items.length; i++) {
          this.orders.push(result.items[i]);
        }
        this.queryInput.skipCount =
          this.queryInput.skipCount + result.items.length;

        this.finished = this.orders.length === result.totalCount;
      } catch (err) {
        return;
      } finally {
        this.loading = false;
        this.dataLoaded = true;
      }
    },
  },
  mounted() {
    let vm = this;
    window.onscroll = function () {
      let currentScrollTop = document.scrollingElement.scrollTop;
      if (currentScrollTop === 0 && vm.scrollTop > 1) {
        window.scrollTo(0, vm.scrollTop);
      } else {
        vm.scrollTop = currentScrollTop;
      }
    };
  },
  beforeRouteLeave(to, from, next) {
    if (this.showOrderInfo) {
      this.onCloseOrderInfo();
      
      next(false);
    } else {
      window.onscroll = null;
      next();
    }
  },
};
</script>

<style scoped>
.dataDiv {
  overflow: auto;
  position: fixed;
  width: 100%;
  height: calc(100vh - 95px);
}
.orderinfo {
  width: 100%;
  height: 100%;
  /* background-color: #f2f2f2; */
}

.jnxeertx {
  width: 75px;
  height: 75px;
  background-position: -11px -170px;
  position: absolute;
  right: 0px;
  top: 84px;
}

.jnxeertx.ab {
  background-position: -126px -170px;
}
.jnxeertx.qr {
  position: absolute;
  right: 0px;
  top: 70px;
  color: #666;
  font-size: 14px;
  font-weight: bold;
}
.cancel {
  height: 75px;
  width: 75px;
  background: url(../assets/img/cancel.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: absolute;
  right: 0px;
  top: 84px;
}
.complete {
  height: 75px;
  width: 75px;
  background: url(../assets/img/complete.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: absolute;
  right: 0px;
  top: 84px;
}
.navBar {
  height: 44px;
  line-height: 44px;
  background: #603531;
  position: fixed;
  width: 100%;
  left: 0;
  top: 0;
  z-index: 3000;
}
</style>
